import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useUserById } from "../../hooks/user/useUserById";
import Loading from "../../components/common/Loading";
import VerificationBadge from "../user/VerificationBadge";

// Accept an additional prop `onRemove` for the remove member action
const MemberDetail = ({
  memberId,
  user: userProp,
  onRemove,
  canRemove,
  isCreator,
}) => {
  const navigate = useNavigate();
  // Prefer the embedded member user (league.memberDetails); only fetch as a
  // fallback so a member list doesn't fire one /users request per row.
  const { data: fetchedUser, isLoading: fetching, error } = useUserById(
    userProp ? undefined : memberId,
  );
  const user = userProp || fetchedUser;

  if (!userProp && fetching) return <Loading fullScreen={false} />;
  if (!userProp && error)
    return <div className="text-medium-grey">Error loading user details</div>;

  // Handle click navigation to user profile
  const handleUserClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (user?._id) {
      navigate(`/users/${user._id}`);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        <div className="w-10 h-10 bg-deep-red/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <FontAwesomeIcon icon={faUser} className="text-deep-red" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <button
              onClick={handleUserClick}
              className="font-semibold text-dark-grey hover:text-deep-red hover:underline cursor-pointer truncate"
              title={`View ${
                user?.username || user?.name || "Unknown User"
              }'s profile`}
            >
              {user?.username || user?.name || "Unknown User"}
            </button>
            {user?.verified && (
              <VerificationBadge
                verified={user.verified}
                size="small"
                showTooltip={true}
              />
            )}
          </div>
          <div className="text-sm text-medium-grey truncate">
            {isCreator ? "League Creator" : "Member"}
          </div>
        </div>
      </div>

      {canRemove && (
        <button
          onClick={() => onRemove(memberId, user?.name)}
          className="ml-3 p-2 text-medium-grey hover:text-deep-red hover:bg-deep-red/10 rounded-lg transition-colors flex-shrink-0"
          title="Remove member"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
};

export default MemberDetail;
